import { defineStore } from 'pinia';


export const useMarketingStore = defineStore('marketing', () => {
  const config = useRuntimeConfig();
  const loading = ref(false)
  const successfulRegistration = ref(false)
  async function registerKlaviyoUser(formData) {

    const options = {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2025-01-15',
        'content-type': 'application/vnd.api+json'
      },
      body: JSON.stringify({
        "data": {
          "type": "subscription",
          "attributes": {
            "profile": {
              "data": {
                "type": "profile",
                "attributes": {
                  "location": {
                    "city": formData.city,
                  },
                  "subscriptions": {
                    "email": {
                      "marketing": {
                        "consent": "SUBSCRIBED",
                      }
                    },
                    "sms": {
                      "marketing": {
                        "consent": "SUBSCRIBED",
                      },
                      "transactional": {
                        "consent": "SUBSCRIBED",
                      }
                    }
                  },
                  "email": formData.email,
                },
              }
            },
            "custom_source": formData.klaviyo_source
          },
          "relationships": {
            "list": {
              "data": {
                "type": "list",
                "id": formData.klaviyo_list_id
              }
            }
          }
        }
      })
    }

    try {

      loading.value = true

      await $fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${config.public.klaviyo_public_key}`, options)
        .then(res => res.json())
        .then(res => console.log(res))
        .catch(err => console.error(err));
      successfulRegistration.value = true
    } catch (e) {
      console.error('Error in sending Klaviyo email registration', e)
    } finally {
      loading.value = false
    }
  }

  return {
    registerKlaviyoUser,
    loading,
    successfulRegistration
  }

})